import { render } from "./PayReportsQ4.vue?vue&type=template&id=bde240f6&scoped=true"
import script from "./PayReportsQ4.vue?vue&type=script&lang=js"
export * from "./PayReportsQ4.vue?vue&type=script&lang=js"

import "./PayReportsQ4.vue?vue&type=style&index=0&id=bde240f6&scoped=true&lang=css"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-bde240f6"]])

export default __exports__